export const DocumentResource = {
  card_id: '',
  card_pic: '',
  card_pic_back: '',
  card_type: '',
  id: '',
  is_verified: false,
}
